import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorIcon from './../../assets/images/error.svg';
import './ErrorBoundaryFallback.scss';

const ErrorBoundaryFallback = ({
    onReset,
    onReload,
    onGoHome,
}) => {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;

    const staticData = {
        title: {
            ua: 'Ой! Щось пішло не так',
            en: 'Oops! Something went wrong',
            ru: 'Упс! Что-то пошло не так',
            pl: 'Ups! Coś poszło nie tak',
            de: 'Hoppla! Etwas ist schief gelaufen',
            es: '¡Vaya! Algo salió mal',
        },
        subtitle: {
            ua: 'Перепрошуємо за незручності. Наша команда вже проінформована та працює над вирішенням проблеми.',
            en: 'We apologize for the inconvenience. Our team has been notified and is working to fix the issue.',
            ru: 'Приносим извинения за неудобства. Наша команда уведомлена и работает над исправлением проблемы.',
            pl: 'Przepraszamy za niedogodności. Nasz zespół został powiadomiony i pracuje nad rozwiązaniem problemu.',
            de: 'Wir entschuldigen uns für die Unannehmlichkeiten. Unser Team wurde benachrichtigt und arbeitet an einer Lösung.',
            es: 'Disculpa las molestias. Nuestro equipo ha sido notificado y está trabajando para solucionar el problema.',
        },
        tryAgain: {
            ua: 'Спробувати знову',
            en: 'Try Again',
            ru: 'Попробовать снова',
            pl: 'Spróbuj ponownie',
            de: 'Erneut versuchen',
            es: 'Intentar de nuevo',
        },
        reloadPage: {
            ua: 'Перезавантажити',
            en: 'Reload Page',
            ru: 'Перезагрузить',
            pl: 'Przeładuj stronę',
            de: 'Seite neu laden',
            es: 'Recargar página',
        },
        goHome: {
            ua: 'На головну',
            en: 'Go Home',
            ru: 'На главную',
            pl: 'Strona główna',
            de: 'Zur Startseite',
            es: 'Ir al inicio',
        },
    };

    return (
        <div className="error__boundary__fallback">
            <div className="error__boundary__container">
                <div className="error__boundary__content">
                    <div className="error__boundary__header">
                        <div className="error__icon">
                            <img className='error__icon__image' src={ErrorIcon} alt="Error-Boundary" loading="lazy"/>
                        </div>
                        <h2 className="error__title">
                            {staticData.title?.[currentLang] || staticData.title?.en}
                        </h2>
                        <p className="error__subtitle">
                            {staticData.subtitle?.[currentLang] || staticData.subtitle?.en}
                        </p>
                    </div>

                    <div className="error__actions">
                        {onReset && (
                            <button
                                className="error__btn"
                                onClick={onReset}
                            >
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                {staticData.tryAgain?.[currentLang] || staticData.tryAgain?.en}
                            </button>
                        )}
                        <button
                            className="error__btn"
                            onClick={onGoHome}
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            {staticData.goHome?.[currentLang] || staticData.goHome?.en}
                        </button>
                        <button
                            className="error__btn"
                            onClick={onReload}
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            {staticData.reloadPage?.[currentLang] || staticData.reloadPage?.en}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ErrorBoundaryFallback;